/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/recurring_run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V2beta1CronSchedule } from './V2beta1CronSchedule';
import {
  V2beta1CronScheduleFromJSON,
  V2beta1CronScheduleFromJSONTyped,
  V2beta1CronScheduleToJSON,
  V2beta1CronScheduleToJSONTyped,
} from './V2beta1CronSchedule';
import type { V2beta1PeriodicSchedule } from './V2beta1PeriodicSchedule';
import {
  V2beta1PeriodicScheduleFromJSON,
  V2beta1PeriodicScheduleFromJSONTyped,
  V2beta1PeriodicScheduleToJSON,
  V2beta1PeriodicScheduleToJSONTyped,
} from './V2beta1PeriodicSchedule';

/**
 * Trigger defines what starts a pipeline run.
 * @export
 * @interface V2beta1Trigger
 */
export interface V2beta1Trigger {
  /**
   *
   * @type {V2beta1CronSchedule}
   * @memberof V2beta1Trigger
   */
  cron_schedule?: V2beta1CronSchedule;
  /**
   *
   * @type {V2beta1PeriodicSchedule}
   * @memberof V2beta1Trigger
   */
  periodic_schedule?: V2beta1PeriodicSchedule;
}

/**
 * Check if a given object implements the V2beta1Trigger interface.
 */
export function instanceOfV2beta1Trigger(value: object): value is V2beta1Trigger {
  return true;
}

export function V2beta1TriggerFromJSON(json: any): V2beta1Trigger {
  return V2beta1TriggerFromJSONTyped(json, false);
}

export function V2beta1TriggerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1Trigger {
  if (json == null) {
    return json;
  }
  return {
    cron_schedule:
      json['cron_schedule'] == null
        ? undefined
        : V2beta1CronScheduleFromJSON(json['cron_schedule']),
    periodic_schedule:
      json['periodic_schedule'] == null
        ? undefined
        : V2beta1PeriodicScheduleFromJSON(json['periodic_schedule']),
  };
}

export function V2beta1TriggerToJSON(json: any): V2beta1Trigger {
  return V2beta1TriggerToJSONTyped(json, false);
}

export function V2beta1TriggerToJSONTyped(
  value?: V2beta1Trigger | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cron_schedule: V2beta1CronScheduleToJSON(value['cron_schedule']),
    periodic_schedule: V2beta1PeriodicScheduleToJSON(value['periodic_schedule']),
  };
}
